module.exports = __webpack_public_path__ + "assets/img/documentation.250402ca.svg";